import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import { MDBBtn, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBIcon, MDBBadge, MDBContainer, MDBRow, MDBCol, MDBNavbar, MDBNavbarToggler, MDBCollapse, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBDropdownMenu, MDBDropdownItem, MDBDropdown, MDBDropdownToggle} from "mdbreact";
import logo from './logo.svg';
import './App.css';
import MyNav from "./Nav"
import BookingForm from "./BookingForm"

function App() {
  return (
    <div className="App">

      <MDBContainer>
      <MDBRow>
        <MDBCol size="7" md="3" className="offset-xl-0 mx-auto">
          <img className="img-fluid" src="https://amanda.net.au/static/img/logo-caption.png" alt="" />
        </MDBCol>
      </MDBRow>
      <MyNav />
      
      <BookingForm />
      
      </MDBContainer>
    </div>
  );
}

export default App;
